export default __webpack_public_path__ + "assets/icons/iconMail.7ce71b8d.svg";